var React = require('react');

function YoutubeIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41.1234 4.68631C40.8843 3.77885 40.4156 2.9513 39.7641 2.28648C39.1125 1.62166 38.3011 1.14289 37.4109 0.898089C34.1344 1.82231e-07 21 0 21 0C21 0 7.86562 -1.82231e-07 4.58906 0.893312C3.69853 1.13732 2.88668 1.61582 2.23503 2.28076C1.58338 2.9457 1.11487 3.77368 0.876562 4.68153C-1.78814e-07 8.02548 0 15 0 15C0 15 -1.78814e-07 21.9745 0.876562 25.3137C1.35937 27.1576 2.78437 28.6099 4.58906 29.1019C7.86562 30 21 30 21 30C21 30 34.1344 30 37.4109 29.1019C39.2203 28.6099 40.6406 27.1576 41.1234 25.3137C42 21.9745 42 15 42 15C42 15 42 8.02548 41.1234 4.68631ZM16.8281 21.4013V8.59873L27.7031 14.9522L16.8281 21.4013Z","fill":"white"}));
}

YoutubeIcon.defaultProps = {"width":"42","height":"30","viewBox":"0 0 42 30","fill":"none"};

module.exports = YoutubeIcon;

YoutubeIcon.default = YoutubeIcon;
